<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'Error' | lang }}</div>
    </header>
    <div>
      <div class="flexcentered bigger" style="text-align: center">
        <i class="fa fa-fw fa-exclamation-triangle" style="margin:1rem auto;align-self:center;font-size:4rem;color:var(--orange)"></i>
        <p style="width:100%;text-align:justify" v-if="isEticket">{{ 'LongWrongTypeCartHelp_Eticket' | lang }}</p>
        <p style="width:100%;text-align:justify" v-else-if="isCscProduct">{{ 'LongWrongTypeCartHelp_CSCproduct' | lang }}</p>
        <!-- <p style="width:100%;text-align:justify" v-else-if="isNewCsc">{{ 'LongWrongTypeCartHelp_NewCSC' | lang }}</p> -->
        <p style="width:100%;text-align:justify">{{ 'WrongTypeCartHelp_Additional' | lang }}</p>
      </div>
    </div>
    <footer>
      <button v-if="cartItems.length === 0" @click="back">{{ 'Back' | lang }}</button>
      <timed-button v-else :disabled="loading" v-on:confirm="empty" :actiontext="dictValue('EmptyTheCart')" :confirmtext="dictValue('Confirm')" />
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import TimedButton from '@/components/TimedButton'
import cartServices from '@/mixins/services/cartServices'

export default {
  name: 'WrongCartType',
  mixins: [ page, cartServices ],
  components: { TimedButton },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    isCscProduct () { return this.$route.params.type === 'csc' },
    isEticket () { return this.$route.params.type === 'eticket' }
    // isNewCsc () { return this.$route.params.type === 'newcsc' }
  },
  methods: {
    empty () {
      this.loading = true
      this._emptyCart()
        .then(() => this.loading = false)
        .catch(() => this.loading = false)
    }
  }
}
</script>

<style></style>
